import { Injectable, NgModule } from '@angular/core';
import { AuthModule, EventTypes, LogLevel, OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';
import { PublicEventsService } from 'angular-auth-oidc-client';
import { filter, flatMap, Observable, of, pipe } from 'rxjs';
import { DaoService } from '../dao/dao.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IUser } from '../models/acustica-user.model';

const MAX_SYNC_TIMEOUT = environment.syncConfiguration.maxSyncTimeout;
const SYNC_KEY = environment.syncConfiguration.key;
const TOKEN_KEY = "f6d764ec-ad9f-4ca3-bf11-4ce73785eee3";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isAdmin: boolean = false;
  user!: IUser;

  constructor(private eventService: PublicEventsService, private dao: DaoService, private toastr: ToastrService, private loader: NgxUiLoaderService, private oidc: OidcSecurityService) {

  }

  getUser() {
    return this.dao.GetUser();
  }

  getSlots() {
    return this.dao.GetSlots();
  }

  getRealmAuthorization() {
    return new Promise((resolve, reject) => {
      this.dao.GetRealmAuthorization()
        .subscribe(
          result => {
            this.isAdmin = true;
            resolve(this.isAdmin);
          },
          error => {
            reject(error);
          })
    })
  }

  sync(force: boolean, disableLoader: boolean = false): Observable<IUser> {
    let lastSync = new Date(JSON.parse(localStorage.getItem(SYNC_KEY) as string));
    let now = new Date();
    let user: IUser;
    if (!force && lastSync && (now.getTime() - lastSync.getTime()) / 1000 < MAX_SYNC_TIMEOUT) return this.getUser();
    if (!disableLoader)
      this.loader.start();
    return this.dao.SetUser()
      .pipe(
        //Sync orders is deprecated
        // flatMap((result) => {
        //   return this.dao.SyncOrders()
        // }),
        flatMap((result) => {
          user = result;
          return this.dao.SyncSlots();
        }),
        flatMap((result) => {
          if (!disableLoader)
            this.loader.stop();
          localStorage.setItem(SYNC_KEY, JSON.stringify(new Date()));
          return of(user);
        }))
  }

  setAuthorizationToken() {
    this.oidc.getAccessToken().subscribe((token) => {
      if (token)
        localStorage.setItem(TOKEN_KEY, token);
    })
  }

  getAuthorizationToken() {
    return localStorage.getItem(TOKEN_KEY);
  }

}
